import React, {useEffect, useState, useMemo} from 'react';
import {useSelector,useDispatch} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getDms, getUserData, setViewer } from '../../redux/actions';
import DeviceSummary from '../DeviceSummary/DeviceSummary';
import { LoaderList } from '../UI/Loader/Loader';
import magnifier from "../../img/magnifier.svg";
import './DevicesList.css';
import { jwtDecode } from 'jwt-decode'; // Добавьте эту библиотеку для декодирования JWT

const DevicesList = ()=>{
  const navigate = useNavigate();
  const role = useSelector((state) => state.userdata?.role);
  const setviewer = useSelector((state) => state.userdata?.setviewer);
  const id = useSelector((state) => state.userdata?.id);
  const token = localStorage.getItem('token'); // Предположим, что токен хранится в localStorage
  const [input,setInput] =useState('');
  const dispatch = useDispatch();
  const [isLoading,setIsLoading]=useState(false);

    // Функция для проверки срока действия токена
    const isTokenExpired = (token) => {
        try {
            const decoded = jwtDecode(token);
            return decoded.exp < Date.now() / 1000;
        } catch (e) {
            return true; // Если токен невалидный, считаем его просроченным
        }
    };

  useEffect(() => {
            if (token === null) {
              navigate('/'); // Перенаправление на общую страницу
            }
          }, [token, navigate]);

  useEffect(() => {
        // Проверяем токен при каждом рендере
        if (!token || isTokenExpired(token)) {
            localStorage.removeItem('token');
            navigate('/');
            return;
        }

        setIsLoading(true);
        const fetchGetDms = async () => {
            try {
                await dispatch(getDms());
                setIsLoading(false);
            } catch (error) {
                // console.error('Ошибка при получении данных:', error);
                // Если ошибка связана с авторизацией, перенаправляем на страницу входа
                if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                    localStorage.removeItem('token');
                    navigate('/');
                }
            }
        };
        fetchGetDms();
    }, [token, navigate, dispatch]);
    
    const datain = useSelector((state) => state);
    console.log(datain);//убрать
    const data = useSelector((state) => state.dm?.data);
    const browserTime = new Date();
    
    //выбор отображения оборудования: ДМ, насосные или всё вместе.
      const dataViwer = setviewer===1 ? (
        data.filter(item => item.type === "круговая" ||item.type === "секторная")
      ) : (
        setviewer===2 ? (data.filter(item => item.type === "RS485")) : (data)
      )
      //настройка просмотра
    function ObjectViewer() {
        const value = setviewer-1;
        const arOptions = ['ДМ', 'Насосные', 'ДМ+Насосные'];
        const options = arOptions.map((text, index) => {
            return <option key={index}  value={index}>{text}</option>;          
        });
            const onClickSetViewer = async(e) => {
            const newValue = e.target.value;
            
            if (setviewer !== (newValue * 1 + 1)) {
                await dispatch(setViewer(id, (newValue * 1 + 1)));
                setInput('');
                await dispatch(getUserData());
            }
        }
        return (
            <div className='DmListViwer'>
                <select className='ObjectViwer' 
                value={value} 
                 onChange={onClickSetViewer}
                 >{options}</select> 
             </div> 
        )
     }
    // Оптимизированная фильтрация с useMemo
      const filteredDms = useMemo(() => {
        if (!dataViwer) return [];
        return dataViwer.filter(item => 
          item.imei_name?.toLowerCase().includes(input.toLowerCase())
        );
      }, [dataViwer, input]);

        return(
            <div className='main-DmList'> 
              <div className='DmListHeader'> 
                <div className='DmListNameViwer'> 
                  <div className='DmListName'> 
                    <h3>Оборудование<span>{dataViwer?.length}</span></h3>
                  </div>
                  {role===1 && 
                  <ObjectViewer />}             
                </div>
                <div className='DmListQuest'> 
                  <input type='text' className='DmListInput' placeholder='Введите название для поиска'
                    value={input}
                    onChange={(e)=>setInput(e.target.value)}
                  /> 
                  {input==='' ? (
                  <img src={magnifier} alt="Result" className='DmListQuestImgMag'/>
                  ) : (
                    <svg  onClick={()=>setInput('')} className='DmListQuestDelet' height="30" viewBox="0 0 200 200" width="30">    
                    <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                </svg>
                  )}
                </div>
              </div> 
              {isLoading ? (<LoaderList />) : (
                      <div className='DmListMainContent'>  
                          {filteredDms.map(item => (
                            <DeviceSummary 
                              item={item} 
                              key={`${item.id}-${item.imei_name}`}
                              browserTime={browserTime}
                            />
                          ))}
                      </div>
              )}
            </div> 
        )
    }
export default DevicesList;